// extracted by mini-css-extract-plugin
export default {"container":"representative-information_container__1Zfmf","wrapper-content":"representative-information_wrapper-content__8n1-G","title":"representative-information_title__ISmWK"};